import { useEffect } from "react";

/** Per-page SEO — updates <title>, meta description and og:title/og:description
 *  on mount. Cleans up on unmount by restoring the defaults from index.html. */
export function useSeo({ title, description, canonical } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    const setMeta = (attr, name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
    return () => { document.title = prevTitle; };
  }, [title, description, canonical]);
}
